// @oasis-permission-inherits: /capcode (capcode:view)
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_dash/capcode/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/capcode/conversations" />;
}
